// Only environment variables prefixed with VUE_APP_ are available in the app

// Customer API key stored in our db
const apiKey = process.env.VUE_APP_API_KEY;

// Backend root URL (e.g. https://edume-api.herokuapp.com)
const backendUrl = process.env.VUE_APP_BACKEND_URL;

// Unique identifier specified in the SAML metadata.xml file
// We use the LFE SAML endpoint (e.g. https://learn.edume.com/auth/beekeeper)
const entityId = process.env.VUE_APP_ENTITY_ID;

// Unique widget identifier, required when registering with Beekeeper
const widgetTypeName = process.env.VUE_APP_WIDGET_TYPE_NAME;

const port = process.env.PORT || 8080;

module.exports = {
  apiKey,
  backendUrl,
  entityId,
  widgetTypeName,
  port
};
